/**
 * Safe wrappers around localStorage that silently handle errors in private
 * browsing mode and when the storage quota is exceeded.
 */

export function safeGetItem(key: string): string | null {
	try {
		return localStorage.getItem(key);
	} catch {
		return null;
	}
}

export function safeSetItem(key: string, value: string): void {
	try {
		localStorage.setItem(key, value);
	} catch {
		// Ignore: private browsing mode or quota exceeded
	}
}

export function safeRemoveItem(key: string): void {
	try {
		localStorage.removeItem(key);
	} catch {
		// Ignore: private browsing mode
	}
}
